var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M256,0c141.386,0,256,114.615,256,256c0,141.386-114.614,256-256,256C114.615,512,0,397.386,0,256 C0,114.615,114.615,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M264.696,59.011h16.223c6.896,0,13.166,2.82,17.706,7.361c4.539,4.539,7.361,10.809,7.361,17.705 v96.139c0,36.281-23.776,59.503-54.193,69.637c-11.657,3.882-24.295,5.829-36.919,5.832c-12.623,0.004-25.256-1.934-36.905-5.818 c-30.346-10.115-54.043-33.312-54.043-69.651v-96.14c0-6.896,2.82-13.165,7.361-17.705h0.014c4.542-4.539,10.805-7.361,17.692-7.361 h16.223v6.684h-16.223c-5.057,0-9.653,2.068-12.987,5.395l0.006,0.007c-3.331,3.332-5.401,7.929-5.401,12.98v96.139 c0,32.971,21.683,54.077,49.448,63.333c10.97,3.655,22.889,5.48,34.815,5.479c11.926-0.002,23.849-1.836,34.829-5.494 c27.839-9.276,49.598-30.405,49.598-63.318V84.076c0-5.051-2.07-9.647-5.401-12.98c-3.332-3.332-7.93-5.402-12.981-5.402h-16.223 V59.011L264.696,59.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M308.213,165.528v14.687c0,37.403-24.448,61.323-55.726,71.744 c-11.881,3.958-24.757,5.941-37.615,5.944c-12.856,0.004-25.728-1.973-37.602-5.93c-31.205-10.403-55.574-34.295-55.574-71.758 v-14.687h11.14v14.687c0,31.848,21.011,52.257,47.917,61.225c10.744,3.582,22.425,5.37,34.118,5.367 c11.693-0.002,23.378-1.797,34.132-5.381c26.979-8.988,48.067-29.422,48.067-61.211v-14.687L308.213,165.528L308.213,165.528z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBECEC"
    },
    cx: 359.448,
    cy: 316.961,
    r: 30.849
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F7986"
    },
    cx: 359.448,
    cy: 316.961,
    r: 26.917
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#076673"
    },
    cx: 359.448,
    cy: 316.961,
    r: 21.189
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBECEC"
    },
    cx: 359.448,
    cy: 316.961,
    r: 16.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.146,
    y: 327.85,
    style: {
      fill: "#FEFEFE"
    },
    width: 8.618,
    height: 26.843
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M365.922,352.676v26.921c0,21.114-8.418,41.174-23.332,56.088 c-14.916,14.917-34.975,23.333-56.09,23.333c-21.116,0-41.18-8.406-56.098-23.322c-14.917-14.919-23.324-34.985-23.324-56.099 V267.785h12.941v111.813c0,17.679,7.045,34.461,19.533,46.947c12.488,12.487,29.271,19.533,46.947,19.533 c17.675,0,34.456-7.056,46.941-19.54c12.486-12.485,19.541-29.265,19.541-46.94v-26.921L365.922,352.676L365.922,352.676z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M152.07,57.6h8.676c1.626-2.765,4.63-4.621,8.067-4.621c5.163,0,9.35,4.187,9.35,9.35 c0,5.164-4.187,9.35-9.35,9.35c-3.438,0-6.441-1.857-8.067-4.622h-8.676V57.6L152.07,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M271.313,57.6h-8.676c-1.625-2.765-4.629-4.621-8.066-4.621c-5.164,0-9.35,4.187-9.35,9.35 c0,5.164,4.186,9.35,9.35,9.35c3.438,0,6.442-1.857,8.066-4.622h8.676V57.6L271.313,57.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M220.121,257.731v16.679h-13.149v-16.844c2.553,0.227,5.116,0.339,7.68,0.338 C216.476,257.902,218.302,257.844,220.121,257.731L220.121,257.731z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F7986"
    },
    cx: 167.503,
    cy: 58.675,
    r: 2.828
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F7986"
    },
    cx: 253.166,
    cy: 58.675,
    r: 2.828
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEFEFE"
    },
    cx: 358.58,
    cy: 316.083,
    r: 15.2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e38f33f8480791182da6175a424e74b.svg";
export { ForwardRef as ReactComponent };